import React from 'react';
import { Layout } from '../components/Layout';
import { Link } from 'react-router-dom';
import { useTranslation } from '../i18n';
import { MapPin, Calendar, MessageCircle, Phone } from 'lucide-react';
import { Button } from '../components/ui/Button';
const BOOKING_URL = 'https://denticoclinic.patientportal.onl/bookings';
const WHATSAPP_URL = 'https://wa.me/447345197820';
export function SitemapPage() {
  const {
    lang
  } = useTranslation();
  return <Layout data-id="element-3326">
      <section className="py-16 bg-white" data-id="element-3327">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-3328">
          <h1 className="text-4xl font-bold text-gray-900 mb-2" data-id="element-3329">
            Dentico Clinic Sitemap
          </h1>
          <p className="text-lg text-gray-600 mb-12" data-id="element-3330">
            Welcome to Dentico Clinic, Private Dental Clinic in Angel, London
            EC1V.
          </p>

          <div className="space-y-10" data-id="element-3331">
            {/* Main Pages */}
            <div data-id="element-3332">
              <h2 className="text-2xl font-bold text-gray-900 mb-4 pb-2 border-b border-gray-200" data-id="element-3333">
                Main Pages
              </h2>
              <ul className="space-y-2.5" data-id="element-3334">
                <li data-id="element-3335">
                  <Link to={`/${lang}`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-3336">
                    Home – Private Dentist in Angel, London
                  </Link>
                </li>
                <li data-id="element-3337">
                  <Link to={`/${lang}/about`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-3338">
                    About Us – Meet Our Dental Team
                  </Link>
                </li>
                <li data-id="element-3339">
                  <Link to={`/${lang}/contact`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-3340">
                    Contact – Book Appointment
                  </Link>
                </li>
              </ul>
            </div>

            {/* Language Versions */}
            <div data-id="element-3341">
              <h2 className="text-2xl font-bold text-gray-900 mb-4 pb-2 border-b border-gray-200" data-id="element-3342">
                Language Versions
              </h2>
              <ul className="space-y-2.5" data-id="element-3343">
                <li data-id="element-3344">
                  <Link to="/en" className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-3345">
                    🇬🇧 English Version
                  </Link>
                </li>
                <li data-id="element-3346">
                  <Link to="/ua" className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-3347">
                    🇺🇦 Ukrainian Version
                  </Link>
                </li>
                <li data-id="element-3348">
                  <Link to="/ru" className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-3349">
                    🇷🇺 Russian Version
                  </Link>
                </li>
              </ul>
            </div>

            {/* Dental Services */}
            <div data-id="element-3350">
              <h2 className="text-2xl font-bold text-gray-900 mb-4 pb-2 border-b border-gray-200" data-id="element-3351">
                Dental Services
              </h2>
              <ul className="space-y-2.5" data-id="element-3352">
                <li data-id="element-3353">
                  <Link to={`/${lang}/services`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-3354">
                    All Services
                  </Link>
                </li>
                <li data-id="element-3355">
                  <Link to={`/${lang}/services/checkup`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-3356">
                    Dental Check-ups
                  </Link>
                </li>
                <li data-id="element-3357">
                  <Link to={`/${lang}/services/hygiene`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-3358">
                    Professional Hygiene & Airflow
                  </Link>
                </li>
                <li data-id="element-3359">
                  <Link to={`/${lang}/services/fillings`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-3360">
                    White Fillings
                  </Link>
                </li>
                <li data-id="element-3361">
                  <Link to={`/${lang}/services/root-canal`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-3362">
                    Root Canal Treatment
                  </Link>
                </li>
                <li data-id="element-3363">
                  <Link to={`/${lang}/services/crowns`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-3364">
                    Crowns & Bridges
                  </Link>
                </li>
                <li data-id="element-3365">
                  <Link to={`/${lang}/services/smile-makeover`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-3366">
                    Veneers & Smile Makeover
                  </Link>
                </li>
                <li data-id="element-3367">
                  <Link to={`/${lang}/services/extraction`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-3368">
                    Tooth Extraction
                  </Link>
                </li>
                <li data-id="element-3369">
                  <Link to={`/${lang}/services/whitening`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-3370">
                    Teeth Whitening
                  </Link>
                </li>
                <li data-id="element-3371">
                  <Link to={`/${lang}/services/cosmetic`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-3372">
                    Cosmetic Treatments
                  </Link>
                </li>
              </ul>
            </div>

            {/* Specialist Pages (UA) */}
            <div data-id="element-3373">
              <h2 className="text-2xl font-bold text-gray-900 mb-4 pb-2 border-b border-gray-200" data-id="element-3374">
                Specialist Pages
              </h2>
              <ul className="space-y-2.5" data-id="element-3375">
                <li data-id="element-3376">
                  <Link to="/ua/ukrainskyi-stomatolog-london" className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-3377">
                    🇺🇦 Ukrainian Dentist in London
                  </Link>
                </li>
                <li data-id="element-3378">
                  <Link to="/ua/implanty-london" className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-3379">
                    Dental Implants in London (UA)
                  </Link>
                </li>
                <li data-id="element-3380">
                  <Link to="/ua/veneers-london" className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-3381">
                    Veneers in London (UA)
                  </Link>
                </li>
                <li data-id="element-3382">
                  <Link to="/ua/root-canal-london" className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-3383">
                    Root Canal in London (UA)
                  </Link>
                </li>
                <li data-id="element-3384">
                  <Link to="/ua/emergency-dentist-london" className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-3385">
                    Emergency Dentist in Angel (UA)
                  </Link>
                </li>
              </ul>
            </div>

            {/* Blog */}
            <div data-id="element-3386">
              <h2 className="text-2xl font-bold text-gray-900 mb-4 pb-2 border-b border-gray-200" data-id="element-3387">
                Blog
              </h2>
              <ul className="space-y-2.5" data-id="element-3388">
                <li data-id="element-3389">
                  <Link to={`/${lang}/blog`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-3390">
                    All Articles
                  </Link>
                </li>
                <li data-id="element-3391">
                  <Link to={`/${lang}/blog/skilky-koshtuyut-implanty-london`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-3392">
                    Скільки коштують імпланти в Лондоні?
                  </Link>
                </li>
                <li data-id="element-3393">
                  <Link to={`/${lang}/blog/nhs-vs-private-dentistry-uk`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-3394">
                    NHS vs Private Dentistry in the UK
                  </Link>
                </li>
                <li data-id="element-3395">
                  <Link to={`/${lang}/blog/likuvannya-zubiv-uk-bez-strakhovky`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-3396">
                    Лікування зубів у UK без страховки
                  </Link>
                </li>
                <li data-id="element-3397">
                  <Link to={`/${lang}/blog/zubnyi-bil-london-shcho-robyty`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-3398">
                    Зубний біль у Лондоні — що робити?
                  </Link>
                </li>
                <li data-id="element-3399">
                  <Link to={`/${lang}/blog/viniry-london-shcho-potribno-znaty`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-3400">
                    Вініри в Лондоні — що потрібно знати
                  </Link>
                </li>
                <li data-id="element-3401">
                  <Link to={`/${lang}/blog/yak-obraty-stomatologa-angel`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-3402">
                    Як обрати стоматолога в Angel
                  </Link>
                </li>
              </ul>
            </div>

            {/* Pricing */}
            <div data-id="element-3403">
              <h2 className="text-2xl font-bold text-gray-900 mb-4 pb-2 border-b border-gray-200" data-id="element-3404">
                Pricing
              </h2>
              <ul className="space-y-2.5" data-id="element-3405">
                <li data-id="element-3406">
                  <Link to={`/${lang}/prices`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-3407">
                    Dental Fees – Transparent Private Prices
                  </Link>
                </li>
              </ul>
            </div>

            {/* Legal */}
            <div data-id="element-3408">
              <h2 className="text-2xl font-bold text-gray-900 mb-4 pb-2 border-b border-gray-200" data-id="element-3409">
                Legal
              </h2>
              <ul className="space-y-2.5" data-id="element-3410">
                <li data-id="element-3411">
                  <Link to={`/${lang}/privacy-policy`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-3412">
                    Privacy Policy
                  </Link>
                </li>
                <li data-id="element-3413">
                  <Link to={`/${lang}/cookie-policy`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-3414">
                    Cookie Policy
                  </Link>
                </li>
                <li data-id="element-3415">
                  <Link to={`/${lang}/patient-privacy-notice`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-3416">
                    Patient Privacy Notice
                  </Link>
                </li>
              </ul>
            </div>
          </div>

          {/* Footer info */}
          <div className="mt-16 pt-8 border-t border-gray-200" data-id="element-3417">
            <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4 text-gray-600" data-id="element-3418">
              <div className="flex items-center gap-2" data-id="element-3419">
                <MapPin className="w-4 h-4 text-teal-600" data-id="element-3420" />
                <span data-id="element-3421">
                  Dentico Clinic · 360–364 City Road · London EC1V 2PY
                </span>
              </div>
            </div>
            <div className="flex flex-wrap gap-3 mt-4" data-id="element-3422">
              <a href={BOOKING_URL} target="_blank" rel="noopener noreferrer" data-id="element-3423">
                <Button size="sm" className="gap-2" data-id="element-3424">
                  <Calendar className="w-4 h-4" data-id="element-3425" />
                  Book Online
                </Button>
              </a>
              <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" data-id="element-3426">
                <Button variant="outline" size="sm" className="gap-2" data-id="element-3427">
                  <MessageCircle className="w-4 h-4 text-green-600" data-id="element-3428" />
                  WhatsApp
                </Button>
              </a>
              <a href="tel:+447345197820" data-id="element-3429">
                <Button variant="outline" size="sm" className="gap-2" data-id="element-3430">
                  <Phone className="w-4 h-4" data-id="element-3431" />
                  Request a Call
                </Button>
              </a>
            </div>
          </div>
        </div>
      </section>
    </Layout>;
}